<template>
    <layout-dashboard-2 style="padding-top: 1.5rem">
        <template #widget-0>
            <app-widget-group :title="$t('portfolio')">
                <v-layout>
                    <v-flex xs3>
                        <app-widget-value
                            :title="$t('total_portfolio_value')"
                            :value="
                                toCurrency(
                                    readStat('portfolio.total_value.amount', 0),
                                    readStat('portfolio.total_value.currency', 'GBP'),
                                    0,
                                    true
                                )
                            "
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-value
                            :title="$t('change_this_month')"
                            :icon-before="readStat('portfolio.change_this_month', 0) > 0 ? getIcon('arrowUp') : null"
                            icon-before-color="success"
                            :value="toPercentage(readStat('portfolio.change_this_month', 0), 0)"
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-value
                            :title="$t('change_this_year')"
                            :icon-before="readStat('portfolio.change_this_year', 0) > 0 ? getIcon('arrowUp') : null"
                            icon-before-color="success"
                            :value="toPercentage(readStat('portfolio.change_this_year', 0), 0)"
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-value
                            :title="$t('cash_on_platform')"
                            :value="
                                toCurrency(
                                    readStat('portfolio.cash_on_platform.amount', 0),
                                    readStat('portfolio.cash_on_platform.currency', 'GBP'),
                                    0,
                                    true
                                )
                            "
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                </v-layout>
            </app-widget-group>
        </template>
        <template #widget-1>
            <app-widget-group :title="$t('investments')">
                <v-layout>
                    <v-flex xs3>
                        <app-widget-value
                            :title="$t('new_investments_this_month')"
                            :value="
                                toCurrency(
                                    readStat('investments.new.month.amount', 0),
                                    readStat('investments.new.month.currency', 'GBP'),
                                    0,
                                    true
                                )
                            "
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-value
                            :title="$t('new_investments_this_year')"
                            :value="
                                toCurrency(
                                    readStat('investments.new.year.amount', 0),
                                    readStat('investments.new.year.currency', 'GBP'),
                                    0,
                                    true
                                )
                            "
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-value
                            :title="$t('applications_in_progress')"
                            :value="
                                toCurrency(
                                    readStat('investments.applications_in_progress.amount', 0),
                                    readStat('investments.applications_in_progress.currency', 'GBP'),
                                    0,
                                    true
                                )
                            "
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-value
                            :title="$t('assets_being_onboarded')"
                            :value="
                                toCurrency(
                                    readStat('investments.assets_being_onboarded.amount', 0),
                                    readStat('investments.assets_being_onboarded.currency', 'GBP'),
                                    0,
                                    true
                                )
                            "
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                </v-layout>
            </app-widget-group>
        </template>
        <template #widget-2>
            <app-widget-group :title="$t('applications')">
                <v-layout>
                    <v-flex xs3>
                        <app-widget-performance
                            :title="$t('shortlists_created')"
                            :value="toNumber(readStat('applications.shortlists_created.number', 0))"
                            :aside="[
                                toCurrency(
                                    readStat('applications.shortlists_created.value.amount', 0),
                                    readStat('applications.shortlists_created.value.currency', 'GBP'),
                                    0,
                                    true
                                )
                            ]"
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-performance
                            :title="$t('proposed_investment')"
                            :value="toNumber(readStat('applications.proposed_investments.number', 0))"
                            :aside="[
                                toCurrency(
                                    readStat('applications.proposed_investments.value.amount', 0),
                                    readStat('applications.proposed_investments.value.currency', 'GBP'),
                                    0,
                                    true
                                )
                            ]"
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-performance
                            :title="$t('awaiting_signatures')"
                            :value="toNumber(readStat('applications.awaiting_signatures.number', 0))"
                            :aside="[
                                toCurrency(
                                    readStat('applications.awaiting_signatures.value.amount', 0),
                                    readStat('applications.awaiting_signatures.value.currency', 'GBP'),
                                    0,
                                    true
                                )
                            ]"
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-performance
                            :title="$t('awaiting_funds')"
                            :value="toNumber(readStat('applications.awaiting_funds.number', 0))"
                            :aside="[
                                toCurrency(
                                    readStat('applications.awaiting_funds.value.amount', 0),
                                    readStat('applications.awaiting_funds.value.currency', 'GBP'),
                                    0,
                                    true
                                )
                            ]"
                            :outlined="false"
                            label-bottom
                            remove-padding
                            :loading="loading.statistics"
                        />
                    </v-flex>
                </v-layout>
            </app-widget-group>
        </template>
        <template #widget-3>
            <app-widget-group class="primaryLight" :loading="setupLoading">
                <v-layout>
                    <v-flex xs3>
                        <app-widget-value
                            :title="$t('profile_complete')"
                            :outlined="false"
                            label-bottom
                            :loading="loading.investor"
                        >
                            <v-progress-circular
                                :size="100"
                                :width="8"
                                :value="investor.$getValidationPercentage() || 0"
                                color="success"
                            >
                                <transition appear name="fade-transition" mode="out-in">
                                    <span
                                        v-if="investor.$getValidationPercentage() !== '100'"
                                        class="text-h4 font-weight-bold success--text text--darken-1"
                                        >{{ investor.$getValidationPercentage() || 0 }}%</span
                                    >
                                    <v-icon v-else color="success" :size="64">{{ getIcon('success', 'fad') }}</v-icon>
                                </transition>
                            </v-progress-circular>
                        </app-widget-value>
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-value
                            :title="$t('account_health')"
                            :value="readStat('account_health', '-')"
                            :outlined="false"
                            label-bottom
                            color="success darken-1"
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-value
                            :title="$t('last_login')"
                            :value="toDatetime(readStat('last_login')) || '-'"
                            :outlined="false"
                            label-bottom
                            :loading="loading.statistics"
                        />
                    </v-flex>
                    <v-flex xs3>
                        <app-widget-performance
                            :title="$t('notifications')"
                            :value="toNumber(readStat('notification', 0))"
                            :outlined="false"
                            label-bottom
                            :loading="loading.statistics"
                        />
                    </v-flex>
                </v-layout>
            </app-widget-group>
        </template>
        <template #widget-4>
            <app-widget-timeline :outlined="false" dense :loading="loading.activity" :events="events" />
        </template>
    </layout-dashboard-2>
</template>

<script>
import { Investor } from '@/models';
import StatisticApi from '@/api/StatisticApi';
import ActivityApi from '@/api/ActivityApi';

export default {
    name: 'InvestorDashboard',
    components: {
        LayoutDashboard2: () =>
            import(
                /* webpackChunkName: "layouts" */
                '@/components/layouts/LayoutDashboard2'
            ),
        AppWidgetGroup: () =>
            import(
                /* webpackChunkName: "widgets" */
                '@/components/widgets/AppWidgetGroup'
            ),
        AppWidgetTimeline: () =>
            import(
                /* webpackChunkName: "widgets" */
                '@/components/widgets/AppWidgetTimeline'
            ),
        AppWidgetPerformance: () =>
            import(
                /* webpackChunkName: "widgets" */
                '@/components/widgets/AppWidgetPerformance'
            ),
        AppWidgetValue: () =>
            import(
                /* webpackChunkName: "widgets" */
                '@/components/widgets/AppWidgetValue'
            )
    },
    data: () => ({
        statistics: null,
        investor: new Investor(),
        events: [],
        loading: {
            investor: true,
            statistics: true,
            activity: true
        }
    }),
    methods: {
        async setup() {
            this.getInvestor();
            this.getStatistics();
            this.getActivity();
        },
        async getInvestor() {
            this.loading.investor = true;

            try {
                this.investor = await Investor.$get(this.Auth().organisation_id);
                this.investor.$hydrateAppropriateness();
            } catch (error) {
                this.handleError(error, () => this.getInvestor());
            }

            this.loading.investor = false;
        },
        async getStatistics() {
            this.loading.statistics = true;

            try {
                const statistics = await new StatisticApi().methods.get('dashboards');
                this.statistics = statistics.data;
            } catch (error) {
                if (error?.code !== 404) {
                    this.handleError(error, () => this.getStatistics());
                }
            }

            this.loading.statistics = false;
        },
        async getActivity() {
            this.loading.activity = true;

            try {
                const activity = await new ActivityApi().methods.index(0, 100, ['date:desc'], {
                    scope: this.getFilterOperator('is') + ':GLOBAL'
                });

                if (activity && 'data' in activity) {
                    this.events = activity.data;
                }
            } catch (error) {
                this.handleError(error, () => this.getActivity());
            }

            this.loading.activity = false;
        },
        readStat(path, fallback = null) {
            return this._.get(this.statistics, path) || fallback;
        }
    }
};
</script>
